import React, { useState } from 'react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato por email tras la compra. Todo en PDF descargable.'
}, {
  q: '¿Sirve para clubes y entrenadores particulares?',
  a: 'Sí. Club, academia, entrenamiento particular o escuela deportiva.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Incluidos en ambas opciones sin costo adicional.'
}, {
  q: '¿Sirve si soy principiante?',
  a: 'Sí, está diseñado desde cero. Abres el tomo, lees 3 minutos y entras a la cancha con todo resuelto.'
}, {
  q: '¿Qué pasa con jugadores de distintos niveles?',
  a: 'Cada sesión incluye variantes para nivel más fácil y más difícil.'
}, {
  q: '¿Incluye entrenamiento específico de portero?',
  a: 'Sí. El Tomo 6 incluye un módulo completo de portería y el Kit Táctico Pro agrega posicionamiento, salidas y técnica de remate.'
}, {
  q: '¿Qué diferencia tiene con otros materiales?',
  a: 'Es el único sistema que cubre técnica, táctica, físico, portería, planificación, evaluación y gestión en un solo lugar.'
}, {
  q: '¿Por qué elegir el Combo con Kit Táctico Pro?',
  a: 'Resuelve el día del partido: tiempo muerto, marcador en contra, portería y dirección táctica clara.'
}, {
  q: '¿Tiene garantía real?',
  a: '30 días sin preguntas. 100% de tu dinero de vuelta si no es lo que esperabas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-87">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-88">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(59,130,246,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-89">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-90">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-91">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-92">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-93">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-94">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-95">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" data-id="element-96"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-97">
            💪 ¡SÍ! QUIERO MEJORAR MI CARRERA AHORA
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-98">
            <span data-id="element-99">⚡ Acceso Inmediato</span>
            <span data-id="element-100">•</span>
            <span data-id="element-101">🛡️ Garantía de 30 Días</span>
          </p>
        </div>
      </div>
    </section>;
}